import { render, staticRenderFns } from "./ClinicSymDic.vue?vue&type=template&id=86874106"
import script from "./ClinicSymDic.vue?vue&type=script&lang=js"
export * from "./ClinicSymDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicSymDic.vue?vue&type=style&index=0&id=86874106&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86874106')) {
      api.createRecord('86874106', component.options)
    } else {
      api.reload('86874106', component.options)
    }
    module.hot.accept("./ClinicSymDic.vue?vue&type=template&id=86874106", function () {
      api.rerender('86874106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicSymDic.vue"
export default component.exports